module.exports = __webpack_public_path__ + "img/朱平.37084abe.png";